module.exports = __webpack_public_path__ + "img/sly3.ea104b21.jpg";